module.exports = __webpack_public_path__ + "static/media/ESPALDAMUJER.257ca057.png";